import { endOfMonth, endOfYear, startOfMonth, startOfYear, subDays, subMonths } from "date-fns";
import { Presets } from "./types";
const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const today = new Date();
const presets = [
    { key: Presets.TODAY, label: "Hoje", start: today, end: today },
    { key: Presets.YESTERDAY, label: "Ontem", start: subDays(today, 1), end: subDays(today, 1) },
    { key: Presets.LAST_7_DAYS, label: "Últimos 7 dias", start: subDays(today, 6), end: today },
    { key: Presets.LAST_30_DAYS, label: "Últimos 30 dias", start: subDays(today, 29), end: today },
    { key: Presets.THIS_MONTH, label: "Este mês", start: startOfMonth(today), end: endOfMonth(today) },
    { key: Presets.LAST_MONTH, label: "Mês passado", start: startOfMonth(subDays(today, today.getDate())), end: endOfMonth(subDays(today, today.getDate())) },
    { key: Presets.THIS_YEAR, label: "Este ano", start: startOfYear(today), end: endOfYear(today) },
    { key: Presets.LAST_3_MONTHS, label: "Últimos 3 meses", start: subMonths(today, 2), end: today },
    { key: Presets.LAST_6_MONTHS, label: "Últimos 6 meses", start: subMonths(today, 5), end: today },
    { key: Presets.LAST_12_MONTHS, label: "Últimos 12 meses", start: subMonths(today, 11), end: today },
    { key: Presets.LAST_YEAR, label: "Ano passado", start: startOfYear(subDays(today, 365)), end: endOfYear(subDays(today, 365)) },
];
export { months, presets };
